import PropTypes from "prop-types";
import styled from "styled-components";

export const Tr = styled.tr`
    font-style: ${props => (props.italic ? "italic" : "inherit")};
    font-weight: ${props => (props.bold ? "bold" : "inherit")};
    border-spacing: 0;
    border-bottom: 1px dotted #ddd;
    padding: 8px;
    page-break-inside: avoid;
    ${props => props.link && "cursor: pointer;"}

    @media print {
        font-style: normal;
    }
`;

Tr.defaultProps = {
    bold: false,
    link: false
};

Tr.propTypes = {
    bold: PropTypes.bool,
    link: PropTypes.bool
};
